module.exports = __webpack_public_path__ + "static/distri_teams-8452a1a72120ce1439ab00ae3811443b.mp4";